module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0d04e32d3d4c908d021182b7872488a8.gif";